import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/admin", { replace: true });
        return;
      }
      try {
        const setupCode = localStorage.getItem("agrivoire_setup_code") || "";
        const headers = { "X-Session-ID": sessionId };
        if (setupCode) headers["X-Setup-Code"] = setupCode;
        const { data } = await api.post("/auth/session", {}, { headers });
        localStorage.removeItem("agrivoire_setup_code");
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Échec de la connexion.");
        setTimeout(() => navigate("/admin", { replace: true }), 2500);
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] text-white" data-testid="auth-callback">
      <div className="text-center">
        {error ? (
          <p className="font-poppins text-red-400">{error}</p>
        ) : (
          <>
            <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-white/20 border-t-[#8CC63F]" />
            <p className="mt-4 font-poppins text-sm text-white/60">Connexion en cours...</p>
          </>
        )}
      </div>
    </div>
  );
}
